/* src/app/merchants/merchant-details/merchant-details.component.css */
/*# sourceMappingURL=merchant-details.component.css.map */
